import MultiSelectBadges from "ui/components/multiselect-badge";
import { useQuery } from "@tanstack/react-query";
import { getDirectusField } from "directus/src/operations";

export function StatusMultiSelect({ values = [], onChange,collection }) {
  const { data = [], isLoading } = useQuery({
    queryKey: [collection, "statuses-multiselect"],
    queryFn: async () => {
      const response = await getDirectusField(collection, "status");
      const choices = response?.meta?.options?.choices || [];
      return choices.map((c) => ({ id: c.value, name: c.text }));
    },
  });

  return (
    <MultiSelectBadges
      data={data}
      valueKey="id"
      values={values}
      onChange={onChange}
      isLoading={isLoading}
    />
  );
}
